import PropTypes from 'prop-types'
import {
  Datagrid,
  DateField,
  ListContextProvider,
  TextField,
  useList,
  useGetList,
} from 'react-admin'
import { Box } from '@mui/material'
import ComponentWrapper from './ComponentWrapper'
import ViewQuoteButton from './ViewQuoteButton'

export default function Notifications({ userId }) {
  const { data, isPending } = useGetList('lead-notifications', {
    pagination: { page: 1, perPage: 1000 },
    filter: {
      'admin.id': userId,
      'quoteRequest.archived': false,
      displayDropped: false,
      dismissed: false,
      noteType: 1,
      payload: 'Follow up',
    },
    sort: { field: 'targetTimestamp', order: 'ASC' },
  })

  const listContext = useList({
    data,
    isPending,
    perPage: 10,
  })

  // Dont show section if data empty
  if (isPending || data === undefined || data.length === 0) {
    return <></>
  }

  return (
    <ComponentWrapper title={'Your Priority notifications'}>
      <ListContextProvider value={listContext}>
        <Datagrid bulkActionButtons={false}>
          <TextField
            label="Vehicle details"
            source="quoteRequest.leadContact.vehicle.registration"
            sx={{ color: '#fc0', fontWeight: 'bold' }}
          />
          <TextField
            label="Note"
            source="payload"
            sx={{
              display: 'block',
              maxHeight: '34px',
              overflow: 'hidden',
            }}
          />
          <DateField
            label="Due time"
            source="targetTimestamp"
            showTime={true}
            locale="en-GB"
            sortable={false}
          />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <ViewQuoteButton />
          </Box>
        </Datagrid>
      </ListContextProvider>
    </ComponentWrapper>
  )
}

Notifications.propTypes = {
  userId: PropTypes.string,
}
